// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Xjmi","rightAdornment":"Header_rightAdornment__3Sw_Y"};